module.exports = __webpack_public_path__ + "static/media/BannerLpBravectoExperienceMob.49e1fb37.webp";